// eslint-disable-next-line
export default function hasAccess(userPermissions: any, action = ''): boolean {
  const divider = ':';

  const [entity, requestedAction] = action.split(divider);

  let permissionsObj;
  try {
    permissionsObj = JSON.parse(userPermissions);
  } catch (e) {
    permissionsObj = userPermissions;
  }

  return permissionsObj && permissionsObj[entity] ? permissionsObj[entity][requestedAction] : false;
}
